'use client';
import React, { useState, useEffect } from 'react';
import LogoutComponent from '../../assets/profileModal/logoutButtonComponent';
import CameraIcon from '../../assets/profileModal/cameraComponent';
import { useAuth0 } from "@auth0/auth0-react";
import profileAvatar from "../../../public/profile-avatar.jpg";
import { updateUser } from '../../utils/apiHandler';

export default function ProfileInfo({ userData }) {
  const { getIdTokenClaims, isAuthenticated, getAccessTokenWithPopup, logout, user } = useAuth0();
  const profileData = {
    name: 'Melanie Fielder',
    brokerageName: 'Navy to Navy',
    email: 'melaniefielder@example.com',
    phone: '229-407-3969',
  };

  const [profileImage, setProfileImage] = useState(profileAvatar);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [showText, setShowText] = useState(false);
  const [showLogout, setShowLogout] = useState(false);
  const [imageFile, setImageFile] = useState(null);

  // Handle image selection
  const handleImageChange = async (event) => {
    const file = event.target.files[0];
    const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];

    if (file && allowedTypes.includes(file.type)) {
      const reader = new FileReader();
      reader.onloadend = async () => {
        const base64Image = reader.result;

        console.log("Base64 Image: ", base64Image);

        setProfileImage(base64Image);
        setImageLoaded(false);
        setImageFile(file);


        const body = {
          profile_image_name: file.name,
          profile_image: base64Image,
        };

        try {
          const isUpdated = await updateUser(
            getIdTokenClaims,
            body,
            false,
            getAccessTokenWithPopup,
            logout
          );

          if (!isUpdated) {
            console.error('Failed to update profile image');
          } else {
            console.log('Profile image updated successfully');
          }
        } catch (error) {
          console.error('Error updating profile image:', error);
        }
      };
      reader.readAsDataURL(file);
    } else {
      alert('Please select a valid image file (png, jpg, jpeg).');
    }
  };

  useEffect(() => {
    const textTimeout = setTimeout(() => setShowText(true), 200);
    const logoutTimeout = setTimeout(() => setShowLogout(true), 400);

    return () => {
      clearTimeout(textTimeout);
      clearTimeout(logoutTimeout);
    };
  }, []);

  const handleLogout = () => {
    logout({ returnTo: 'https://usedeli.com' });
  };

  return (
    <div className="flex flex-col items-center space-y-4 font-[poppins] max-sm:min-h-[100vh]">
      <div className="relative">
        <div className="">
          <img
            src={userData?.profile_image_url}
            alt="Profile"
            height={150}
            width={150}
            className="rounded-full object-contain border-4 border-white shadow-lg"
          />
        </div>

        <label htmlFor="fileInput" className="absolute bottom-2 right-2 cursor-pointer">
          <CameraIcon className="w-8 h-8 text-gray-700 bg-white rounded-full shadow-md p-1" />
        </label>

        <input
          type="file"
          id="fileInput"
          accept="image/png, image/jpg, image/jpeg"
          onChange={handleImageChange}
          className="hidden"
        />
      </div>


      <div className={`text-center profile_info-text ${showText ? 'show' : ''}`}>
        <p className="font-semibold text-xl">{userData?.first_name} {userData?.last_name}</p>
        {/* <p className="text-sm text-gray-500">{profileData.brokerageName}</p> */}
        <p className="text-sm text-gray-500">{userData?.email}</p>
        <p className="text-sm text-gray-500">{userData?.mobile_number || "Phone Number"}</p>
      </div>


      <div
        className={`flex items-center space-x-2 border-[2px] border-[#0062ff] rounded-full px-[10px] py-2 mt-4 profile_info-logout-button ${showLogout ? 'show' : ''}`}
        onClick={handleLogout}
      >
        <LogoutComponent />
        <button className="text-[#0062ff] hover:underline flex space-x-2 text-sm sm:text-lg">
          LOG OUT
        </button>
      </div>
    </div>
  );
}
